import { Breadcrumb, Card, Layout, Row } from 'antd'
import ActivityDisplay from '../../../../components/Corporate/Analytics/Reports/ReportsComponents/Activity/ActivityDisplay'
import ClientDisplay from '../../../../components/Corporate/Analytics/Reports/ReportsComponents/Client/ClientDisplay'
import POAndPayPlanDisplay from '../../../../components/Corporate/Analytics/Reports/ReportsComponents/POAndPayPlan/POAndPayPlanDisplay'
import SalesContribDisplay from '../../../../components/Corporate/Analytics/Reports/ReportsComponents/SalesContrib/SalesContribDisplay'
import VendorDisplay from '../../../../components/Corporate/Analytics/Reports/ReportsComponents/Vendor/VendorDisplay'
import PageTitle from '../../../../elements/PageTitle'
import _ from 'lodash'
import React, { Fragment } from 'react'
import Switch, { Case, Default } from 'react-switch-case'

const { Content } = Layout

function Report(props) {
  const { reportType } = props
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Corporates</Breadcrumb.Item>
              <Breadcrumb.Item href="#/corporates/analytics">Analytics</Breadcrumb.Item>
              <Breadcrumb.Item href={`#/corporates/analytics/${reportType}`}>
                {_.upperFirst(reportType)} Report
              </Breadcrumb.Item>
            </Breadcrumb>
            {reportType ? (
              <PageTitle
                title={_.upperFirst(reportType)}
                subtitle={_.upperFirst(reportType)}
                color={'#427035'}
                iconType={'file-unknown'}
              />
            ) : (
              <PageTitle
                title={'Business Analytics Reports'}
                subtitle={'This is the Reports area'}
                color={'#427035'}
                iconType={'file-unknown'}
              />
            )}
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <Switch condition={reportType}>
              <Case value="activity">
                <ActivityDisplay {...props} />
              </Case>
              <Case value="vendor">
                <VendorDisplay {...props} />
              </Case>
              <Case value="client">
                <ClientDisplay {...props} />
              </Case>
              <Case value="salesContribution">
                <SalesContribDisplay {...props} />
              </Case>
              <Case value="purchasesAndPayPlanReport">
                <POAndPayPlanDisplay {...props} />
              </Case>
              <Default>
                <span>Nothing!</span>
              </Default>
            </Switch>
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

Report.propTypes = {}
Report.defaultProps = {}

export default Report
